module.exports = __webpack_public_path__ + "static/media/mk2_pic-3.48bea13e.jpg";